export enum ReservationErrorMessageKeys {
  ERROR_DEPOSIT_REQUIRED_KEY = 'payment.error.rate.deposit',
  AVAILABILITY_ERROR_052163_KEY = 'availability.error.guests052163', //
  AVAILABILITY_ERROR_052109_KEY = 'availability.error.dates052109', // product not available
  AVAILABILITY_ERROR_052150_KEY = 'availability.error.dates052150',
  AVAILABILITY_ERROR_052113_KEY = 'availability.error.dates052113',
  AVAILABILITY_ERROR_058800_KEY = 'availability.error.dates058800',
  AVAILABILITY_ERROR_ONE_NIGHT_KEY = 'availability.error.rooms052138', // message: 1 room max
  ERROR_FREE_NIGHTS_KEY = 'availability.error.free.nights.invalid',
  ACCESS_OTA_ERROR_052149_KEY = 'reservation.error.access.ota', // message: some reservations cant be viewed here
  SECURITY_ERROR_073501_KEY = 'reservation.error.security073501',
  SECURITY_ERROR_073502_KEY = 'reservation.error.security073502',
  MODIFY_ERROR_UNKNOWN_KEY = 'reservation.modify.error.unknown',
  RETRIEVE_ERROR_UNKNOWN_KEY = 'reservation.retrieve.error.unknown',
  RESERVATION_NOT_FOUND_KEY = 'reservation.retrieve.not.found',
  AVAILABILITY_ERROR_UNKNOWN_KEY = 'availability.error.unknown',
  ASSOCIATION_ERROR_UNKNOWN_KEY = 'association.error.unknown',
  JOIN_ERROR_UNKNOWN_KEY = 'association.error.unknown',
  ADD_GUESTS_ERROR_UNKNOWN_KEY = 'addguests.error.message',
  SUCCESS_GLOBAL_AVAILABILITY = 'availability.success.global',
  SUCCESS_STAY_AVAILABILITY = 'availability.success.stay',
  SUCCESS_GLOBAL_STAY_PREFERENCES = 'staypreferences.success.general',
  SUCCESS_LOCAL_STAY_PREFERENCES = 'staypreferences.success.local',
  SUCCESS_ADD_GUESTS = 'addguests.success',
  ERROR_UNKNOWN_KEY = 'reservation.error.unknown',
  // Member does not have access to the reservation
  ERROR_ACCESS = 'reservation.modify.error.access', // user must be signed in
  // Member is required to modify the reservation
  ERROR_AUTHORIZATION = 'reservation.modify.error.authorization',
  MEMBER_REQUIRED_ERROR = 'reservation.modify.error.member',
  ERROR_FREE_NIGHTS_ROOMS_KEY = 'availability.error.free.nights.rooms',
  CANCELED_RESERVATION = 'reservation.canceled.error',
  SERVICE_DOWN = 'reservation.service.down',
  ERROR_GREATERCHINA = 'reservation.modify.greater.china.nonrefundable',
  // v2 mappings
  MAX_OCCUPANCY_EXCEEDED_KEY = 'availability.error.guests052163', // max occupancy exceeded
  PRODUCT_NOT_AVAILABLE_KEY = 'availability.error.dates052109', // product not available
  PREFERENCES_NOT_EDITABLE = 'non.editable.preferences',
  SUCCESS_SAVE_PREFERENCES = 'preferences.save.success',
  INVALID_DATES_KEY = 'availability.error.dates058800',
  ALREADY_CANCELLED_KEY = 'errors.cancelled.default.text'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/errors/reservation-error-message-keys.model.ts